// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1040":"cea7844b","4163":"cea7844b","5302":"ba8fe149","8095":"cea7844b","8150":"cea7844b","8391":"4e638ce2"}[chunkId] + ".chunk.css";
};